import { render, staticRenderFns } from "./VoiceVolumeSelector.vue?vue&type=template&id=6bf9cd2c"
import script from "./VoiceVolumeSelector.vue?vue&type=script&lang=js"
export * from "./VoiceVolumeSelector.vue?vue&type=script&lang=js"
import style0 from "./VoiceVolumeSelector.vue?vue&type=style&index=0&id=6bf9cd2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports